import { EventoAbility } from './eventos.ability';

/**
 * Itens de navegação de um evento — a fonte única da sidebar.
 *
 * Vivia dentro de `eventos-insert-edit.component.ts`. Saiu de lá para que a
 * tela de check-in (rota própria) consuma a mesma lista sem importar o
 * componente inteiro: item de menu é dado, não é detalhe daquela tela.
 *
 * `permission` é AUTORIZAÇÃO (CASL), não feature flag — responde "este usuário
 * pode ver esta área?". Se a área toda precisar ser ligada/desligada, isso é
 * uma flag em `core/config/features`, e são checagens independentes.
 */
export interface MenuItemViewModel {
  page: string;
  title: string;
  icon: string;
  permission: (ability: EventoAbility) => boolean;
}
export var MENU_ITEMS:MenuItemViewModel[] = [
  {
    page: 'dashboard',
    title: 'Dashboard',
    icon: 'assets/icones/menu/dashboard.svg',
    permission: (ability: EventoAbility) => ability.can('read', 'Dashboard')
  },
  {
    page: 'informacoes',
    title: 'Informações',
    icon: 'assets/icones/menu/informacoes.svg',
    permission: (ability: EventoAbility) => ability.can('read', 'Informacoes')
  },
  {
    page: 'lotes',
    title: 'Lotes',
    icon: 'assets/icones/menu/lotes.svg',
    permission: (ability: EventoAbility) => ability.can('read', 'Lotes')
  },
  {
    page: 'produtos',
    title: 'Produtos',
    icon: 'assets/icones/menu/produtos.svg',
    permission: (ability: EventoAbility) => ability.can('read', 'Produtos')
  },
  {
    page: 'checkins',
    title: 'Check-ins',
    icon: 'assets/svg/camera2.svg',
    permission: (ability: EventoAbility) => ability.can('read', 'Check-ins')
  },
  {
    page: 'controleEntradaSaida',
    title: 'Entrada/Saída',
    icon: 'assets/icones/menu/checkins.svg',
    permission: (ability: EventoAbility) => ability.can('read', 'ControleEntradaSaida')
  },
  {
    page: 'vendas',
    title: 'Vendas',
    icon: 'assets/icones/menu/vendas.svg',
    permission: (ability: EventoAbility) => ability.can('read', 'Vendas')
  },
  {
    page: 'cupons',
    title: 'Cupons',
    icon: 'assets/icones/menu/cupons.svg',
    permission: (ability: EventoAbility) => ability.can('read', 'Cupons')
  },
  {
    page: 'convites',
    title: 'Convites',
    icon: 'assets/icones/menu/convites.svg',
    permission: (ability: EventoAbility) => ability.can('read', 'Convites')
  },
  {
    page: 'lineUp',
    title: 'Atrações',
    icon: 'assets/icones/menu/atracoes.svg',
    permission: (ability: EventoAbility) => ability.can('read', 'Atracoes')
  },
  {
    page: 'saques',
    title: 'Saques',
    icon: 'assets/icones/menu/saques.svg',
    permission: (ability: EventoAbility) => ability.can('read', 'Saques')
  },
  {
    page: 'permissoes',
    title: 'Permissões',
    icon: 'assets/icones/menu/permissoes.svg',
    permission: (ability: EventoAbility) => ability.can('read', 'Permissoes')
  },
  {
    page: 'importacaoPlanilhas',
    title: 'Planilhas',
    icon: 'assets/icones/menu/informacoes.svg',
    permission: (ability: EventoAbility) => ability.can('read', 'ImportacaoPlanilhas')
  },
  {
    page: 'integracoes',
    title: 'Integrações',
    icon: 'assets/icones/menu/informacoes.svg',
    permission: (ability: EventoAbility) => ability.can('read', 'Integracoes')
  },
  {
    page: 'configuracaoAdmin',
    title: 'Configurações',
    icon: 'assets/icones/evento/gerenciar.svg',
    permission: (ability: EventoAbility) => ability.can('read', 'Certificados')
  }
]
